/**
 * Custom JS by MaxDesign
 */

// init custom code at the begining of this file
if (document.body.dataset.template == 'collection') collectionInfiniteLoading();
if (document.body.dataset.template == 'product') {
  mediaGalleryArrow();
  updateVariantMetafields();
}

/**********************************************************************************************************/

/**
 * Make custom arrows interact with product media gallery
 */
function mediaGalleryArrow() {
  const mediaGallery = document.querySelector('media-gallery');
  const arrows = document.querySelectorAll('.slider-arrow');
  for (let arrow of arrows) {
    arrow.addEventListener('click', function () {
      const activeMedia = mediaGallery.querySelector('.product__media-item.is-active');
      const mediaId = this.hasAttribute('data-next')
        ? (activeMedia.nextElementSibling && activeMedia.nextElementSibling.dataset.mediaId) ||
          activeMedia.parentElement.firstElementChild.dataset.mediaId
        : (activeMedia.previousElementSibling && activeMedia.previousElementSibling.dataset.mediaId) ||
          activeMedia.parentElement.lastElementChild.dataset.mediaId;
      mediaGallery.setActiveMedia(mediaId);
    });
  }
}

/**********************************************************************************************************/

/**
 * Update variant metafields on variant change
 */
function updateVariantMetafields() {
  const productVariants = document.querySelector('[id^=ProductInfo] variant-radios, [id^=ProductInfo] variant-selects');
  const metaVariants = document.querySelector('.meta-items--variants');
  if (productVariants && metaVariants)
    productVariants.addEventListener('change', function () {
      this.currentVariant && (metaVariants.dataset.activeVariant = this.currentVariant.id);
    });
}

/**********************************************************************************************************/

/**
 * Infinite loading on colleciton page
 * Added pagination url support for SEO purposes
 * {@link https://developers.google.com/search/docs/crawling-indexing/javascript/lazy-loading}
 */
function collectionInfiniteLoading() {
  customElements.define(
    'infinite-loader',
    class InfiniteLoader extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.closest('.shopify-section').id.replace('shopify-section-', '');
        this.observer = new IntersectionObserver(this.callback.bind(this), {
          rootMargin: '0px 0px 99% 0px',
        });
        this.observer.observe(this);
        this.allowEntry = true;
      }

      callback(entries) {
        for (let entry of entries) {
          if (entry.isIntersecting && this.allowEntry) {
            // get next page url & prevent new entries until then
            this.allowEntry = false;
            this.pageIndex = {
              current: +this.dataset.progress.split('/')[0],
              max: +this.dataset.progress.split('/')[1],
            };
            if (this.pageIndex.current >= this.pageIndex.max) {
              this.observer.disconnect();
              this.hidden = true;
              break;
            }
            this.pageIndex.next = this.pageIndex.current + 1;
            this.nextPageUrl = this.addOrUpdateURLParam('page', this.pageIndex.next) + `&section_id=${this.sectionId}`;
            this.appendPage();
          }
        }
      }

      appendPage() {
        fetch(this.nextPageUrl)
          .then(response => response.text())
          .then(responseText => {
            const htmlToAppend = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('#product-grid').innerHTML;
            this.previousElementSibling.insertAdjacentHTML('beforeend', htmlToAppend);
            this.dataset.progress = this.pageIndex.next + '/' + this.pageIndex.max;
            this.allowEntry = true;
          })
          .catch(console.error);
      }

      addOrUpdateURLParam(key, value) {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set(key, value);
        const newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
        history.pushState(null, '', newRelativePathQuery);
        return newRelativePathQuery;
      }
    }
  );
}

/**********************************************************************************************************/
